// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={219}
    height={137}
    viewBox="0 0 219 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 0H219V137H0V0Z"
      fill="#FFFDF6"
    />
    <path
      d="M131 59.0369H88V56.5184C88 55.8505 88.2665 55.2099 88.7408 54.7376C89.2152 54.2653 89.8586 54 90.5294 54H128.471C129.141 54 129.785 54.2653 130.259 54.7376C130.734 55.2099 131 55.8505 131 56.5184V59.0369Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M128.471 87.9991H90.5294C89.8586 87.9991 89.2152 87.7338 88.7408 87.2615C88.2665 86.7892 88 86.1486 88 85.4807V59.0371H131V85.4807C131 86.1486 130.734 86.7892 130.259 87.2615C129.785 87.7338 129.141 87.9991 128.471 87.9991V87.9991Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M123.413 57.7782C124.112 57.7782 124.678 57.2144 124.678 56.519C124.678 55.8235 124.112 55.2598 123.413 55.2598C122.715 55.2598 122.148 55.8235 122.148 56.519C122.148 57.2144 122.715 57.7782 123.413 57.7782Z"
      fill="#29292F"
    />
    <path
      d="M127.202 57.7782C127.901 57.7782 128.467 57.2144 128.467 56.519C128.467 55.8235 127.901 55.2598 127.202 55.2598C126.504 55.2598 125.938 55.8235 125.938 56.519C125.938 57.2144 126.504 57.7782 127.202 57.7782Z"
      fill="#29292F"
    />
    <path
      d="M106.97 64.0742H94.3233C93.6248 64.0742 93.0586 64.638 93.0586 65.3334V81.7033C93.0586 82.3987 93.6248 82.9625 94.3233 82.9625H106.97C107.669 82.9625 108.235 82.3987 108.235 81.7033V65.3334C108.235 64.638 107.669 64.0742 106.97 64.0742Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M124.678 71.6289H113.296C112.597 71.6289 112.031 72.1927 112.031 72.8881V81.7026C112.031 82.3981 112.597 82.9619 113.296 82.9619H124.678C125.377 82.9619 125.943 82.3981 125.943 81.7026V72.8881C125.943 72.1927 125.377 71.6289 124.678 71.6289Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.857143}
      strokeLinejoin="round"
    />
    <path
      d="M112.145 64.3301H126.197"
      stroke="#29292F"
      strokeWidth={0.857143}
    />
    <path
      d="M112.145 68.6328H126.197"
      stroke="#29292F"
      strokeWidth={0.857143}
    />
    <path
      d="M112.145 66.4824H126.197"
      stroke="#29292F"
      strokeWidth={0.857143}
    />
    <path
      d="M77 42.2631L77.4342 42.2773C79.1754 42.3366 80.8201 43.0357 82.0063 44.2208C83.1926 45.4059 83.8235 46.9799 83.7601 48.5968L83.7428 49L83.7601 48.5968C83.7915 47.7961 83.9924 47.009 84.3514 46.2805C84.7104 45.5519 85.2205 44.8961 85.8525 44.3506C86.4845 43.8052 87.226 43.3806 88.0348 43.1013C88.8435 42.822 89.7036 42.6934 90.5658 42.7227L91 42.7389L90.5658 42.7227C89.7035 42.6936 88.8559 42.5071 88.0713 42.1737C87.2867 41.8403 86.5805 41.3667 85.993 40.7798C85.4056 40.193 84.9484 39.5044 84.6476 38.7534C84.3468 38.0025 84.2082 37.2038 84.2399 36.4032L84.2551 36L84.2399 36.4032C84.2085 37.2039 84.0076 37.991 83.6486 38.7195C83.2896 39.4481 82.7795 40.1039 82.1475 40.6494C81.5155 41.1948 80.774 41.6194 79.9652 41.8987C79.1565 42.178 78.2964 42.3066 77.4342 42.2773L77 42.2631Z"
      fill="white"
      stroke="#29292F"
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M72.3101 57.3458C73.5539 57.3869 74.7286 57.8708 75.576 58.6913C76.4233 59.5117 76.8739 60.6015 76.8287 61.7209C76.8511 61.1666 76.9946 60.6216 77.251 60.1172C77.5075 59.6128 77.8718 59.1589 78.3232 58.7812C78.7746 58.4036 79.3043 58.1097 79.882 57.9163C80.4596 57.7229 81.074 57.6339 81.6899 57.6542C81.074 57.6341 80.4685 57.5049 79.9081 57.2741C79.3476 57.0433 78.8432 56.7154 78.4236 56.3091C78.004 55.9028 77.6774 55.4261 77.4626 54.9062C77.2477 54.3863 77.1487 53.8334 77.1714 53.2791C77.149 53.8334 77.0054 54.3784 76.749 54.8828C76.4925 55.3872 76.1282 55.8411 75.6768 56.2188C75.2254 56.5964 74.6957 56.8903 74.118 57.0837C73.5404 57.2771 72.926 57.3661 72.3101 57.3458Z"
      fill="white"
    />
    <path
      d="M72 57.336L72.3101 57.3458M72.3101 57.3458C73.5539 57.3869 74.7286 57.8708 75.576 58.6913C76.4233 59.5117 76.8739 60.6015 76.8287 61.7209M72.3101 57.3458C72.926 57.3661 73.5404 57.2771 74.118 57.0837C74.6957 56.8903 75.2254 56.5964 75.6768 56.2188C76.1282 55.8411 76.4925 55.3872 76.749 54.8828C77.0054 54.3784 77.149 53.8334 77.1714 53.2791M76.8287 61.7209L76.8163 62M76.8287 61.7209C76.8511 61.1666 76.9946 60.6216 77.251 60.1172C77.5075 59.6128 77.8718 59.1589 78.3232 58.7812C78.7746 58.4036 79.3043 58.1097 79.882 57.9163C80.4596 57.7229 81.074 57.6339 81.6899 57.6542M81.6899 57.6542L82 57.6654M81.6899 57.6542C81.074 57.6341 80.4685 57.5049 79.9081 57.2741C79.3476 57.0433 78.8432 56.7154 78.4236 56.3091C78.004 55.9028 77.6774 55.4261 77.4626 54.9062C77.2477 54.3863 77.1487 53.8334 77.1714 53.2791M77.1714 53.2791L77.1822 53"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgLiveDemoPlaceholder = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgLiveDemoPlaceholder;
